module.exports = __webpack_public_path__ + "img/w11-qr.2be82dfe.jpg";